import axios from 'axios'
function adjustTrack (params) {
  const { event_token, data } = params

  if (localStorage.getItem('adid')) {
    axios({
      url: 'https://s2s.adjust.com/event',
      method: 'POST',
      data: {
        adid: localStorage.getItem('adid'),
        event_token,
        s2s: 1,
        app_token: process.env.VUE_APP_ADJUST_APP_TOKEN,
        callback_params: JSON.stringify({
          app_version: process.env.VUE_APP_VERSION,
          app_version_raw: process.env.VUE_APP_VERSION,
          app_version_short: process.env.VUE_APP_VERSION,
          app_name: process.env.VUE_APP_PACKAGE_NAME,
          ...data
        })
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    // 在浏览器里面打点使用 打点方式 adjust sdk
  } else {
    const myd = []
    for (const t in data) {
      myd.push({ key: t, value: data[t] })
    }
    Adjust.trackEvent({
      eventToken: event_token,
      callbackParams: [
        { key: 'app_version', value: process.env.VUE_APP_VERSION },
        { key: 'app_version_raw', value: process.env.VUE_APP_VERSION },
        { key: 'app_version_short', value: process.env.VUE_APP_VERSION },
        { key: 'app_name', value: process.env.VUE_APP_PACKAGE_NAME },
        ...myd
      ]
    })
  }
}

export default {
  install (Vue, options) {
    Vue.prototype.$adjustTrack = adjustTrack
  }
}
